import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=156df0b0&scoped=true&"
import script from "./disclaimers.vue?vue&type=script&lang=ts&"
export * from "./disclaimers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156df0b0",
  null
  
)

export default component.exports